/**
 * Trigger: tr_categories_soft_delete
 * Purpose: Cascade soft delete to related entities when a category is soft deleted
 * Table: categories
 * Event: UPDATE OF is_deleted
 */
export const TR_CATEGORIES_SOFT_DELETE = `
CREATE TRIGGER tr_categories_soft_delete
UPDATE OF is_deleted ON categories
BEGIN
  UPDATE categories
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM categories),
      updated_at = strftime('%s', 'now')
  WHERE parent_category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM expenses),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM incomes),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE planned_expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_expenses),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE planned_incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_incomes),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE creditors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM creditors),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE debtors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtors),
      updated_at = strftime('%s', 'now')
  WHERE category_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;
END;
`;
